import styled from 'styled-components';
import Button from '../Button';
import { IoClose } from 'react-icons/io5';
import { blueGray, detailsBackground, outlineGray, primaryColor, primaryColorLight } from '../../config/colors';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';

export const Container = styled.div`
  width: calc(100% - 15px);
  display: flex;
  flex-direction: column;
`;

export const UpperSection = styled.div`
  display: grid;
  grid-template-rows: auto auto auto auto 50px;
  grid-row-gap: 1rem;
`;

export const Section = styled.div`
  border: 1px solid transparent;
`;

export const BelowSection = styled.div`
  margin-top: 1rem;
  margin-top: 100px;
`;

export const FirstSection = styled(Section)`
  display: grid;
  height: 37.5vh;
  overflow-y: auto;
  grid-template-columns: 63% auto;
  position: relative;

  @media only screen and (min-width: 2000px) {
    & {
      height: 30vh;
    }
  }
`;

export const SecondSection = styled(Section)``;

export const AddToCurrentSectionButton = styled.a`
  color: ${primaryColor};
  font-size: 1rem;
  border-radius: 4px;
  padding: 0px 8px;
  height: 40px;
  display: inline-flex;

  padding: 4px 18px;

  transition: border-color 0.3s ease-out;

  border: 1px solid ${outlineGray};
  cursor: pointer;

  &:hover {
    border: 1px solid ${primaryColor};
  }

  & .add-to-layout {
    position: relative;
    top: 3px;
    cursor: inherit;
    font-weight: 700;
    margin-left: 1rem;
  }
`;

export const CommandsWrapper = styled.div`
  height: 40px;
  width: 200px;
  position: absolute;
  right: 0px;
  display: flex;
  flex-direction: row-reverse;
  padding: 0px 8px;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Right = styled.div`
  padding-right: 16px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.1rem;
  margin-top: 8px;
  padding: 4px 8px;
`;

export const PrimaryImageContainer = styled.div`
  border-radius: 25%;
  box-shadow: 0px 1px 15px rgb(0 0 0 / 20%);

  overflow: hidden;
  position: relative;
  margin-top: 70px;
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 4px;
`;

export const Content = styled.label`
  font-size: 0.8rem;
  word-wrap: break-word;
`;

export const Image = styled.img`
  border-radius: 0.8rem;
  box-shadow: 0px 1px 15px rgb(0 0 0 / 20%);
`;

export const Header = styled.h3`
  height: 32px;
  margin: 0px;
  padding: 0px 1rem;
  display: flex;
  font-size: 1.2rem;
  font-weight: normal;
  line-height: 32px;
`;

export const ComparisonSubMenuWrapper = styled.div`
  position: relative;
`;
